import { render, staticRenderFns } from "./MediaResource.vue?vue&type=template&id=db561b90&scoped=true&"
import script from "./MediaResource.vue?vue&type=script&lang=js&"
export * from "./MediaResource.vue?vue&type=script&lang=js&"
import style0 from "./MediaResource.vue?vue&type=style&index=0&id=db561b90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db561b90",
  null
  
)

export default component.exports